var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0669 6.18306C13.311 6.42714 13.311 6.82286 13.0669 7.06694L7.06694 13.0669C6.82286 13.311 6.42714 13.311 6.18306 13.0669C5.93898 12.8229 5.93898 12.4271 6.18306 12.1831L12.1831 6.18306C12.4271 5.93898 12.8229 5.93898 13.0669 6.18306Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18306 9.18306C7.42714 8.93898 7.82286 8.93898 8.06694 9.18306L10.0669 11.1831C10.311 11.4271 10.311 11.8229 10.0669 12.0669C9.82286 12.311 9.42714 12.311 9.18306 12.0669L7.18306 10.0669C6.93898 9.82286 6.93898 9.42714 7.18306 9.18306Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18306 7.18306C9.42714 6.93898 9.82286 6.93898 10.0669 7.18306L12.0669 9.18306C12.311 9.42714 12.311 9.82286 12.0669 10.0669C11.8229 10.311 11.4271 10.311 11.1831 10.0669L9.18306 8.06694C8.93898 7.82286 8.93898 7.42714 9.18306 7.18306Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.625C0 13.2798 0.279822 13 0.625 13C2.11684 13 3.54758 13.5926 4.60248 14.6475C5.65737 15.7024 6.25 17.1332 6.25 18.625C6.25 18.9702 5.97018 19.25 5.625 19.25C5.27982 19.25 5 18.9702 5 18.625C5 17.4647 4.53906 16.3519 3.71859 15.5314C2.89812 14.7109 1.78532 14.25 0.625 14.25C0.279822 14.25 0 13.9702 0 13.625Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.625C0 6.09982 6.09982 0 13.625 0C15.1168 0 16.5476 0.592632 17.6025 1.64752C18.6574 2.70242 19.25 4.13316 19.25 5.625C19.25 13.1502 13.1502 19.25 5.625 19.25C4.13316 19.25 2.70242 18.6574 1.64752 17.6025C0.592632 16.5476 0 15.1168 0 13.625ZM13.625 1.25C6.79018 1.25 1.25 6.79018 1.25 13.625C1.25 14.7853 1.71094 15.8981 2.53141 16.7186C3.35188 17.5391 4.46468 18 5.625 18C12.4598 18 18 12.4598 18 5.625C18 4.46468 17.5391 3.35188 16.7186 2.53141C15.8981 1.71094 14.7853 1.25 13.625 1.25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.625 0C13.9702 0 14.25 0.279822 14.25 0.625C14.25 1.78532 14.7109 2.89812 15.5314 3.71859C16.3519 4.53906 17.4647 5 18.625 5C18.9702 5 19.25 5.27982 19.25 5.625C19.25 5.97018 18.9702 6.25 18.625 6.25C17.1332 6.25 15.7024 5.65737 14.6475 4.60248C13.5926 3.54758 13 2.11684 13 0.625C13 0.279822 13.2798 0 13.625 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/football.0f4c5268eecd3de62fd10f0fd3795122.svg";
export { ForwardRef as ReactComponent };